import { render, staticRenderFns } from "./cfss-footer.component.vue?vue&type=template&id=74de8ec8&"
import script from "./cfss-footer.component.ts?vue&type=script&lang=ts&"
export * from "./cfss-footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./cfss-footer.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports